import { Building2, Users, LayoutGrid, ShieldCheck, type LucideIcon } from 'lucide-react';

/**
 * Route map for the admin sidebar. Sprint 1 scope is intentionally narrow —
 * only routes that have backing API + UI work in this sprint appear here.
 * DO NOT add routes that are not implemented — the nav rendering a dead link
 * is a UX failure.
 *
 * Flutter admin module map (for reference, source of the eventual full nav):
 *   super_admin_module/    — tenant_list, create_tenant
 *   org_admin_module/      — organization_overview, organization_departments_module,
 *                            organization_practitioners_module, access_control_module,
 *                            organization_audit_trail_module, organization_users,
 *                            organization_sub_organizations_module, organization_roles_permissions
 */

export interface AdminNavItem {
  label: string;
  path: string;
  icon: LucideIcon;
}

export const superAdminRoutes: AdminNavItem[] = [
  { label: 'Organisations', path: '/admin/super/organisations', icon: Building2 },
];

export const orgAdminRoutes: AdminNavItem[] = [
  { label: 'Overview', path: '/admin/org/overview', icon: LayoutGrid },
  { label: 'Departments', path: '/admin/org/departments', icon: Building2 },
  { label: 'Practitioners', path: '/admin/org/practitioners', icon: Users },
  { label: 'Access Control', path: '/admin/org/access-control', icon: ShieldCheck },
];
